import Reveal from "../Reveal";
import { PHOTOS } from "../../lib/site";

const TILES = [
  { img: PHOTOS.embassy1, label: "Royal Bhutanese Embassy · New Delhi", tag: "180 kW", cls: "md:col-span-8 md:row-span-2 h-72 md:h-full" },
  { img: PHOTOS.schoolChd300, label: "Institutional · Chandigarh", tag: "300 kW", cls: "md:col-span-4 h-72" },
  { img: PHOTOS.carportKharar100, label: "Solar carport · Kharar", tag: "100 kW", cls: "md:col-span-4 h-72" },
  { img: PHOTOS.punjab500, label: "Industrial · Punjab", tag: "500 kW", cls: "md:col-span-6 h-72" },
  { img: PHOTOS.resChd20, label: "Residential · Chandigarh", tag: "20 kW", cls: "md:col-span-6 h-72" },
];

export default function Gallery() {
  return (
    <section id="projects" data-testid="gallery" className="bg-sand py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal className="mb-12 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <p className="text-xs uppercase tracking-[0.25em] text-gold">Our work</p>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-forest md:text-5xl">
              Real rooftops. Real savings. Across the Tricity.
            </h2>
          </div>
          <a href="#quote" className="shrink-0 rounded-full border border-forest px-6 py-3 text-sm font-semibold text-forest transition-colors hover:bg-forest hover:text-cream">
            Start your project
          </a>
        </Reveal>

        <div className="grid auto-rows-[18rem] grid-cols-1 gap-5 md:grid-cols-12">
          {TILES.map((t, i) => (
            <Reveal key={i} delay={i * 0.06} className={t.cls}>
              <div className="group relative h-full w-full overflow-hidden rounded-3xl">
                <img src={t.img} alt={t.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                  <p className="font-heading text-lg font-bold text-cream">{t.label}</p>
                  <span className="rounded-full bg-gold px-3 py-1 font-mono text-xs font-semibold text-obsidian">{t.tag}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
